import {
  DELETE_HIGHLIGHT,
  SET_LINK_URL,
  SET_POSTS,
  SET_POSTS_HIGHLIGHTS,
  SET_POST_CONTENT,
  SET_POST_GROUP,
  SET_POST_HIGHLIGHTS,
  SET_POST_NOTE,
  SET_POST_STATUS,
  SET_POST_TAGS,
  SET_POST_GROUPS_LIST,
  SET_POST_TITLE,
  SET_SELECTED_POST,
  SET_SELECTED_POST_DATE,
  UPDATE_POST_HIGHLIGHT,
  UPDATE_POST_LIST,
  UPDATE_POST_LIST_CONFIG,
  SET_POST_TAGS_LIST,
} from '../../constants';

import {
  createPost,
  deletePost,
  getPostHighlights,
  getPosts,
  getPostDetails,
  getTags,
} from '../../../services';

import { IReduxAction } from '../../interfaces';
import { IPostListConfig } from '../reducers';
import { deleteHighlight, updatePost } from '../../../services/posts';
import { IGroupListConfig } from '../../groups/reducers/groupsReducer';
import { getGroupsByLeaderId } from '../../../services/groups/service';

export const createPostAction = async (userId: string, dispatch: any) => {
  const post: any = await createPost(userId);
  dispatch(setSelectedPostAction(post.post));
};

export const deletePostAction = async (postId: string) => {
  await deletePost(postId);
};

export const deleteHighlightAction = async (highlight: any, dispatch: any) => {
  await deleteHighlight(highlight);
  dispatch({
    payload: highlight.id,
    type: DELETE_HIGHLIGHT,
  });
};

export const getPostsAction = async (userId: string, config: IPostListConfig, dispatch: any) => {
  const postList: any = await getPosts(userId, config);
  dispatch(setPostListAction(postList.posts));
  return postList.posts.length;
};

export const getTagsListAction = async (userId: string, dispatch: any) => {
  const tagsList: any = await getTags(userId);
  dispatch(setTagsListAction(tagsList.tags));
};

export const getGroupsListAction = async (userId: string, dispatch: any) => {
  const groupsList: any = await getGroupsByLeaderId(userId);
  dispatch(setGroupsListAction(groupsList));
};

export const getPostsHighlights = async (postId: string, dispatch: any) => {
  const highlights = await getPostHighlights(postId);
  dispatch({
    type: SET_POSTS_HIGHLIGHTS,
    payload: {
      postId,
      highlights,
    },
  });
};

export const getPostHighlightsAction = async (postId: string, dispatch: any) => {
  const postHighlights = await getPostHighlights(postId);
  dispatch(setPostHighlightsAction(postHighlights));
};

export const getPostNotesAction = async (postId: string, dispatch: any) => {
  const postNotes: any[] = [];
  dispatch(setSelectedPostAction(postNotes));
};

export const getPostDetailsAction = async (postId: string | null, dispatch: any) => {
  const post = postId ? await getPostDetails(postId) : null;
  dispatch(setSelectedPostAction(post));
};

export const setSelectedPostAction = (payload: any): IReduxAction => ({
  payload,
  type: SET_SELECTED_POST,
});

export const setPostListAction = (payload: any): IReduxAction => ({
  payload,
  type: SET_POSTS,
});

export const setTagsListAction = (payload: any): IReduxAction => ({
  payload,
  type: SET_POST_TAGS_LIST,
});

export const setGroupsListAction = (payload: any): IReduxAction => ({
  payload,
  type: SET_POST_GROUPS_LIST,
});

export const setPostHighlightsAction = (payload: any): IReduxAction => ({
  payload,
  type: SET_POST_HIGHLIGHTS,
});

export const setPostGroup = async (dispatch: any, payload: any) => {
  await updatePost(payload);
  dispatch({ payload, type: SET_POST_GROUP });
};

export const setSelectedPostDate = async (dispatch: any, payload: any) => {
  await updatePost(payload);
  dispatch({
    payload,
    type: SET_SELECTED_POST_DATE,
  });
};

export const setPostTitle = async (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: SET_POST_TITLE,
  });
};

export const setLinkURL = (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: SET_LINK_URL,
  });
};

export const setPostTags = (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: SET_POST_TAGS,
  });
};

export const setPostedStatus = (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: SET_POST_STATUS,
  });
};

export const setPostContent = (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: SET_POST_CONTENT,
  });
};

export const setPostNote = (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: SET_POST_NOTE,
  });
};

export const setPostUpdates = (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: UPDATE_POST_LIST,
  });
};

export const updatePostHighlight = (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: UPDATE_POST_HIGHLIGHT,
  });
};

export const updatePostListConfig = (payload: any, dispatch: any) => {
  dispatch(({
    payload,
    type: UPDATE_POST_LIST_CONFIG,
  }));
};
